.uic-breadcrumb {
    display: flex;
    align-items: center;
    height: 40px;

    .uic-breadcrumb-item:first-of-type uic-icon:first-of-type {
        display: none;
    }

    &.override {
        .uic-breadcrumb-item {
            &__dots {
                display: none;
            }

            &__label {
                display: inline;
            }
        }
    }
}
